<script>
import {VueMaskDirective as mask} from 'v-mask'
import service, {emitirGev} from '../../../../domain/grv/services'
import moment from 'moment'
import {STATUS_NO_LEILAO} from '../../../../domain/grv/helpers/GrvStatus'
import PopupViewer from '../../../_default/components/popup-viewer/PopupViewer'
import AddPreretirada from '../../../website/preretirada/components/addPreretirada'
import GrvConsultaPagamento from '../../../website/preretirada/components/ConsultaPagamento'
import {GRV_POLICIA_CIVIL} from '../../../../domain/grv/helpers/tipos-grv'
import {
  FAVORECIDO_APL,
  FAVORECIDO_DETRO,
  FAVORECIDO_STRINGS
} from '../../../../domain/grv/helpers/pre-retirada-favorecidos'
import LogDetroGrvPatio from '../../../website/grvs/components/grv-patio/LogDetroGrvPatio'
import BtnCorrigirDiarias from '../../../website/grvs/components/grv-patio/BtnCorrigirDiarias'
import BtnAlteraStatusGrv from '../../../website/grvs/components/grv-patio/BtnAlteraStatusGrv'
import createDownloadLink from '../../../../utils/create-download-link'
import CardNewsItem from '../../../website/grvs/components/grv-patio/CardNewsItem'
import {mockExtraModelDataHora} from '../../../../domain/grv/helpers/grv-mock'
import CardNewsItemResumo from '../../../website/grvs/components/grv-patio/CardNewsItemResumo'
import CardNewsItemPagamento from '../../../website/grvs/components/grv-patio/CardNewsItemPagamento'
import GrvPatioMixins from '../../../website/grvs/mixins/GrvPatioMixins'
import BtnAlterarRegraMeioDia from '../../../website/grvs/components/grv-patio/BtnAlterarRegraMeioDia'
import BtnUploadArquivoGrv from '../../../website/grvs/components/grv-patio/BtnUploadArquivoGrv'

const TIPO_REMOCAO_RODANDO = 1

export default {
  name: 'grv-patio',
  components: {
    BtnUploadArquivoGrv,
    BtnAlterarRegraMeioDia,
    CardNewsItemPagamento,
    CardNewsItemResumo,
    CardNewsItem,
    BtnAlteraStatusGrv,
    BtnCorrigirDiarias,
    LogDetroGrvPatio,
    GrvConsultaPagamento,
    AddPreretirada,
    PopupViewer,
    Gev: () => import('./Gev')
  },
  directives: {mask},
  mixins: [GrvPatioMixins],
  data () {
    return {
      extraModel: JSON.parse(JSON.stringify(mockExtraModelDataHora)),
      data: null,
      isLoading: false,
      showConsultaPagamento: false,
      calculo: null,
      preretiradaConsulta: null,
      STATUS_NO_LEILAO,
      newStatus: null,
      openAlteracaoStatusSelect: false,
      showFormGev: false,
      isFullyLoaded: false,
      FAVORECIDO_DETRO,
      FAVORECIDO_APL,
      FAVORECIDO_STRINGS,
      interval: null,
      alertaRegistrarNovaPreRetirada: false
    }
  },
  computed: {
    isGrvPolicia () {
      return this.data.tipoProcesso === GRV_POLICIA_CIVIL
    },
    isTipoRemocaoRodando () {
      return this.data.tipoRemocao === TIPO_REMOCAO_RODANDO
    }
  },
  created () {
    this.start()
  },
  beforeDestroy () {
    if (this.interval !== null) clearInterval(this.interval)
  },
  methods: {
    start () {
      if (this.$route.params.id && this.$route.params.id !== 'registrar') {
        this.$loaderOverlay.open().message('Carregando GRV')
        service.find(this.$route.params.id, this.isGgv, true)
          .then((response) => {
            let data = response.data

            let dataRemocao = JSON.parse(JSON.stringify(data.data))
            this.extraModel.dataRemocao = moment(dataRemocao.date).format('L')
            this.extraModel.horaRemocao = moment(dataRemocao.date).format('LT')
            let dataApreensao = JSON.parse(JSON.stringify(data.dataApreensao))
            this.extraModel.dataApreensao = moment(dataApreensao.date).format('L')
            this.extraModel.horaApreensao = moment(dataApreensao.date).format('LT')

            data.gev = data.gev ? data.gev.id : null

            this.data = data
            this.calculoCustos()
            console.log(response)
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      }
    },
    emitirGev () {
      this.$loaderOverlay.open().message('Gerando GEV...')
      emitirGev(this.data.ggv.id)
        .then(response => {
          createDownloadLink(response.data, `GEV_${this.data.numero}.pdf`)
          this.$loaderOverlay.hide()
        })
        .catch(error => {
          alert('Houve um erro ao executar a operação')
          console.log(error.data)
          this.$loaderOverlay.hide()
        })
    },
    adicionarPreRetirada () {
      if (!this.data.renavam) {
        alert('Esta GRV não possui RENAVAM. Corrija antes de prosseguir com a pré-retirada')
        return
      }
      this.$router.push({name: 'preretirada.adicionar', params: {id: this.data.id}})
    },
    openFormGev () {
      this.showFormGev = true
    },
    closeFormGev (gevId = null) {
      if (gevId) {
        this.data.gev = gevId
      }
      // this.start()
      this.showFormGev = false
    },
    registrarPreRetirada () {
      this.alertaRegistrarNovaPreRetirada = true
      setTimeout(() => {
        const confirma = confirm('Registrar nova pré-retirada para esta GRV?')
        if (!confirma) {
          this.alertaRegistrarNovaPreRetirada = false
          return
        }
        this.$router.push({ name: 'preretirada.adicionar', params: { id: this.data.id } })
      }, 900)
    }
  }
}
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition" v-if="isFullyLoaded">

      <div class="bg-warning lter b-b wrapper-md m-t " v-if="alertaRegistrarNovaPreRetirada">
        <div class="row">
          <div class="col-xs-12">
            <h1 class="font-thin h4 text-black">
              <strong>Atenção</strong><br>
              Confira os dados da GRV antes de registrar uma nova pré-retirada
            </h1>
          </div>
        </div>
      </div>
      <div class="estoqueHeader">
        <div class="grv-bar">
          <div>
            <div class="grv-status-div">GRV <strong>{{data.numero}}</strong> criada
              {{moment(data.data.date).fromNow()}} / {{ data.placaOriginal ? 'Placa Original' : 'Chassi' }}: <strong>{{data.placaOriginal || data.chassi || '-'}}</strong>
              <div>{{data.marca || '-'}} / {{data.modelo || '-'}} - {{data.cor || '-'}} - {{data.ano || '-'}}</div>
            </div>
          </div>
          <div class="flex-right column-flex">
            <div class="text-right m-r-xxl">
              {{data.bemCategoria.nome}}
              <br>
              <span class="text-danger" v-if="isTipoRemocaoRodando">Tipo de remoção: RODANDO</span>
              <br>
              <router-link :to="{name: 'roubo-furto.list', query: {grv: data.numero}}" class="pull-right hidden-print m-t-sm" style="clear: left">
                <strong class="label no-radius bg-info">Voltar</strong>
              </router-link>
            </div>
          </div>
        </div>

        <div class="posbar">
          <div class="grv-status">
            <div>Situação atual</div>
            <div class="status-insights">{{StatusTitle(data.status)}}</div>
            <div v-if="data.status === STATUS_NO_LEILAO && ACL.check('alterar_status_grv', currentUser.id)">
              <button class="btn btn-danger font-bold btnlock" @click="excluirLote">
                Retirar lote do leilão
              </button>
            </div>
            <btn-altera-status-grv
              v-if="ACL.check('alterar_status_grv', currentUser.id)"
              @statusAlterado="start"
            ></btn-altera-status-grv>
          </div>
          <div class="grv-status cursor-pointer_">
            <div class="status-insights text-center">
              <u-fake-loader v-if="!calculo" width="20px" class="m-t"></u-fake-loader>
              <span v-else>{{calculo.base.diarias}}</span>
            </div>
            <div class="row-flex flex-center ">diária{{+calculo.base.diarias !== 1 ? 's' : ''}}</div>
            <div class="m-t-sm row-flex flex-center" v-if="ACL.check('corrigir_estadas', currentUser.id)">
              <btn-corrigir-diarias
                :quantidade-diarias-atual="calculo.base.diarias"
                :grv-id="$route.params.id"
                @corrigido="start"
              ></btn-corrigir-diarias>
            </div>
            <div class="m-t-sm">
              <btn-alterar-regra-meio-dia
                :grv-id="$route.params.id"
                :is-regra-meio-dia-ativada="!calculo.base.desabilitarRegraMeioDia"
                ocultar-apos-meio-dia
                @alterado="start"
                v-if="isAdministradorExclusivo"
              ></btn-alterar-regra-meio-dia>
            </div>
          </div>
          <div class="grv-status cursor-pointer_">
            <div class="status-insights text-center">
              <u-fake-loader v-if="!calculo" width="20px" class="m-t"></u-fake-loader>
              <span v-else>R$ {{calculo.base.saldoDevedor|moeda}}</span>
            </div>
            <div class="row-flex flex-center ">saldo devedor <!--<svg-seta/>--></div>
            <div class="row-flex flex-center text-sm text-danger-dker" v-if="calculo.base.cobrarTaxaNotificacaoAR">
              +R$ {{calculo.custos.valorTaxaNotificacaoAR|moeda}} taxa de notificação AR
            </div>
          </div>
          <div class="grv-status gmin cursor-pointer_">
            <div class="status-insights text-center">
              <u-fake-loader v-if="!calculo" width="20px" class="m-t"></u-fake-loader>
              <div v-else>R$ {{calculo.custos.valorDiaria|moeda}}</div>
            </div>
            <div class="row-flex flex-center ">diária <!--<svg-seta/>--></div>
          </div>
          <div class="grv-status gmin cursor-pointer_">
            <div class="status-insights text-center">
              <u-fake-loader v-if="!calculo" width="20px" class="m-t"></u-fake-loader>
              <div v-else>R$ {{calculo.custos.valorReboque|moeda}}</div>
            </div>
            <div class="row-flex flex-center ">reboque <!--<svg-seta/>--></div>
          </div>
        </div>
      </div>
      <div class="newsfeed">
        <card-news-item-resumo
          :grv="data"
          :data-limite-gratuidade="calculo.base.dataLimiteGratuidade"
          :datas-extra-model="extraModel"
          :data-agendamento="calculo.base.dataAgendamento"
        ></card-news-item-resumo>

        <card-news-item title="Pré-Retirada" v-if="!isRetiradoPorLeilao && !isDataUltimoLeilaoMenorQueHoje">
          <div class="row m-t">
            <div class="col-xs-12" v-if="!data.preretiradas">
              Nenhuma pré-retirada registrada
              <div class="m-t">
                <button
                  class="btn btn-info btn-block"
                  @click="$router.push({name: 'preretirada.adicionar', params: {id: data.id}})"
                >
                  Registrar pré-retirada
                </button>
              </div>
            </div>
            <div class="col-xs-12" v-else>
              <div v-for="preretirada in data.preretiradas" class="m-b">
                Registrada para {{moment(preretirada.dataPrevista.date).format('LL')}} no valor de R$
                {{preretirada.valor|moeda}} e status <strong
                :class="'text-' + StatusPreRetirada[preretirada.status].class">{{StatusTitlePreRetirada(preretirada.status)}}</strong>.
                <br>
                Favorecido: {{FAVORECIDO_STRINGS[preretirada.favorecido]}}
                <div>
                  <a v-if="preretirada.status === 0 && preretirada.favorecido === FAVORECIDO_DETRO" :href="preretirada.urlBoleto"
                     target="_blank"
                     class="btn btn-xs btn-primary btn-block m-t-xs"
                  >
                    <i class="fa fa-barcode"></i> Ver boleto
                  </a>
                  <a v-if="preretirada.status === 0 && preretirada.favorecido === FAVORECIDO_APL"
                     @click="emitirGuiaPagamento(preretirada)"
                     target="_blank"
                     class="btn btn-xs btn-primary btn-block m-t-xs"
                  >
                    <i class="fa fa-barcode"></i> Guia de pagamento
                  </a>
                  <a @click="consultaPagamento(preretirada)" class="btn btn-xs btn-default btn-block m-t-xs">
                    <i class="fa fa-search"></i> Consultar pagamento
                  </a>
                  <a @click="excluirPreRetirada(preretirada.id)"
                     class="btn btn-xs btn-danger btn-block m-t-xs"
                     v-if="isAdministradorExclusivo &&  preretirada.status === 3"
                  >
                    <i class="fa fa-trash"></i> Excluir pré-retirada
                  </a>
                </div>
              </div>
              <div class="m-t">
                <!-- <div v-if="isTipoRemocaoRodando" class="text-loading">
                  Aguardando autorização para emissão de pré-retiradas...
                </div> -->
                <button
                  class="btn btn-info btn-block"
                  :disabled="ACL.check('coordES', currentUser.id)"
                  @click="registrarPreRetirada"
                >
                  Registrar nova pré-retirada
                </button>
              </div>
            </div>
          </div>
        </card-news-item>

        <card-news-item-pagamento
          :calculo="calculo"
          :preretiradas="data.preretiradas"
          :grvId="data.id"
          :grvPatioPix="data.patio.chavePix"
          :prospsTxid="data.txidPixPatio"
          v-if="!isRetiradoPorLeilao"
        ></card-news-item-pagamento>

        <card-news-item title="Retirada" class="hidden-print">
          <div v-if="!data.retirada" class="hidden-print">
            <u-fake-loader v-if="!calculo" width="100%" class="m-t"></u-fake-loader>
            <div v-else class="row m-t">
              <div class="col-xs-12" v-if="hasPendencias">
                Este veículo ainda <strong class="nao-apto">não está apto</strong> para retirada. Pendências:
                <div class="m-t">
                  <ul>
                    <li v-if="!data.preretiradas">Gerar pré-retirada</li>
                    <li v-if="data.preretiradas && calculo.base.valorPago === 0">Efetuar pagamento.</li>
                    <li v-if="data.preretiradas && calculo.base.saldoDevedor > 0">Valore(s) pago(s) não batem com o
                      saldo devedor. Resta a pagar <strong>R${{calculo.base.saldoDevedor|moeda}}</strong>. Registre
                      uma nova pré-retirada para que seja efetuado o pagamento.
                    </li>
                    <li v-if="data.preretiradas && calculo.base.saldoDevedor < 0">Inconsistência nos valores pagos.
                      Foi efetuado um pagamento superior ao valor devido, faça o reembolso de <strong
                        class="text-success">R${{Math.abs(calculo.base.saldoDevedor)|moeda}}</strong>.
                      Caso queira efetuar a retirada mesmo assim, prossiga com o processo.
                    </li>
                  </ul>
                </div>
                <div class="m-t">
                  <button class="btn btn-warning btn-block" @click="retirada">Registrar retirada mesmo assim</button>
                </div>
              </div>
              <div class="col-xs-12" v-else>
                <div class="text-center text-3x"><i class="fa fa-check-circle text-success"></i></div>
                Este veículo está <strong class="apto">apto</strong> para retirada.
                <div class="m-t">
                  <button class="btn btn-block btn-success" @click="retirada">Registrar retirada</button>
                </div>
              </div>
            </div>
          </div>
          <div class="hidden-print" v-else>
            Veículo retirado {{moment(data.retirada.dataRetirada.date).format('LLL')}}
            <div class="m-t">
              <a @click="emitirDocumentoRetirada" class="btn btn-default btn-block"><i class="fa fa-print m-r-sm"></i> Emitir retirada</a>
            </div>
            <div class="m-t" v-if="ACL.check('alterar_retirada_grv', currentUser.id)">
              <button class="btn btn-warning btn-block" @click="retirada"><i class="fa fa-print m-r-sm"></i>Editar retirada</button>
            </div>
            <div class="m-t" v-if="isAdministradorExclusivo">
              <button class="btn btn-danger btn-block" @click="excluirRetirada"><i class="fa fa-trash-o m-r-sm"></i>Excluir retirada</button>
            </div>
          </div>
          <btn-upload-arquivo-grv
            class="m-t"
            :grv="data"
            @reload="start"
          />
        </card-news-item>

        <card-news-item title="GEV" v-if="isGrvPolicia" class="hidden-print">
          <div v-if="true">
            <div class="row m-t">
              <div class="col-xs-12">
                Este veículo foi apreendido pela Polícia Civil. Faz-se necessário, portanto, o cadastro da Guia de Entrega de Veículo (GEV) <br><br>
              </div>
              <div class="col-xs-12">
                <div class="m-t">
                  <button class="btn btn-danger btn-block" @click="openFormGev" v-if="!data.gev">Cadastrar GEV</button>
                  <button class="btn btn-success btn-block" @click="openFormGev" v-else>Visualizar/Editar GEV</button>
                  <button class="btn btn-default btn-block" v-if="data.gev" @click="emitirGev">Imprimir GEV</button>
                </div>
              </div>
            </div>
          </div>
        </card-news-item>
      </div>

      <log-detro-grv-patio></log-detro-grv-patio>

      <popup-viewer @close="closeConsultaPagamento" v-if="showConsultaPagamento" :title="'Consultar Pagamento de Boleto GRV ' + data.numero ">
        <grv-consulta-pagamento :preretirada="preretiradaConsulta" @statusPagamentoAlterado="start"/>
      </popup-viewer>

      <popup-viewer @close="closeFormGev" v-if="showFormGev" title="Cadastro de GEV">
        <gev @finishSubmit="closeFormGev" :grv="data" :gevId="data.gev" />
      </popup-viewer>
    </div>
  </transition>
</template>

<style lang="scss" src="../../../website/grvs/assets/scss/grv-patio.scss" scoped></style>



// WEBPACK FOOTER //
// GrvPatio.vue?898bfb14